import Pin from "../../../../systemDesign/Sep/Pin";
import DeployCard from "./Cards/DeployCard";

const Deploy = () => {
  return (
    <div className="w-full relative flex flex-col gap-10 lg:flex-row justify-center items-center mt-4 lg:py-20 lg:mt-6 border-y border-stroke1 px-5 lg:pl-10">
      <h3 className="text-text2 text-[18px] mini:text-[24px] md:text-[28px] max-w-[700px] mt-10">
        <span className="text-text3">
          Deploy an AI app in seconds on Vercel,
        </span>{" "}
        using our pre-built templates.
      </h3>
      <Pin className="-right-[9.6px] top-[50px] scale-150" />
      <div className="w-full flex justify-between items-center gap-2">
        <DeployCard title="To summarize any document." number={5} unit="Sec" />
        <DeployCard
          title="Time saved: On routine tasks."
          number={75}
          unit="%"
        />
        <DeployCard
          title="Cost reduction: In legal services."
          number={90}
          unit="%"
          unitClassName="!-right-4"
        />
      </div>
    </div>
  );
};

export default Deploy;
